export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "What areas does MGL Cleaning Solutions serve?",
    a: "We're based in Germantown, TN and serve the surrounding Memphis area — including Collierville, Cordova, Bartlett, Eads, East Memphis, and Memphis.",
  },
  {
    q: "What cleaning services do you offer?",
    a: "We offer deep cleaning, regular recurring cleaning, move-in / move-out cleaning, one-time cleaning, and office cleaning for local businesses.",
  },
  {
    q: "How much does a cleaning cost?",
    a: "Pricing depends on the size of your space, the type of cleaning, and how often you'd like us there. Every quote is a free, no-pressure written estimate — just tell us about your space and we'll send you a clear price.",
  },
  {
    q: "Do you provide cleaning supplies and equipment?",
    a: "Yes. We bring our own cleaning products, cloths, mops, and vacuums to every visit. You don't need to have anything ready for us.",
  },
  {
    q: "What hours are you open?",
    a: "We're open Monday through Friday, 8:00 AM to 5:00 PM. Reach out any time through the form on this site and we'll get back to you during business hours.",
  },
  {
    q: "What's the difference between a deep clean and a regular clean?",
    a: "A regular clean covers ongoing maintenance — kitchens, bathrooms, floors, dusting, and high-touch surfaces. A deep clean adds the detail work: baseboards, inside appliances, grout, blinds, ceiling fans, door frames, and vents. Most new customers start with a deep clean, then move to a recurring regular plan.",
  },
  {
    q: "Do you clean empty homes for a move?",
    a: "Yes — move-in / move-out cleaning is one of our core services. We clean inside cabinets, drawers, closets, ovens, and refrigerators so the home is ready for your landlord, buyer, or new tenant.",
  },
  {
    q: "Do you clean offices and businesses?",
    a: "We do. We clean offices, professional suites, and small business spaces across Germantown and the Memphis area — desks, breakrooms, restrooms, conference rooms, and lobbies on a recurring schedule that fits your business day.",
  },
];
